module.exports = __webpack_public_path__ + "img/greylarrykingbettervert.9ee2218f.webp";